export const environment = {
  production: false,
  apiUrl: 'https://dev.tgaaayodhya.com/api',
  websiteUrl: 'https://dev.tgaaayodhya.com',
  allowedWebsiteUrls: [
    'https://dev.tgaaayodhya.com'
  ],
  recaptchaSiteKey: '6LcmL6ssAAAAAIjEFJsRwsyjv388b03zeIRajznh ',
  appName: 'Tour Guide Welfare Association of Ayodhya Ji',
  appVersion: '1.0.0',
};
